import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "परिचय", "id": "about" },
    { "name": "शोध परियोजनाएं", "id": "research-projects" },
    { "name": "सेमीनार/सम्मेलन/कार्यशाला", "id": "seminars-workshops" },
    { "name": "शोधार्थी", "id": "research-scholars" },
    { "name": "उपलब्धियां", "id": "achievements" },
    { "name": "सम्पर्क", "id": "contact" }
];

const contentData = {
    "about": {
        title: "परिचय",
        content: (
            <>
                <p>इस केंद्र की स्थापना दिनांक 18 जुलाई 2024 को विश्वविद्यालय की आठवीं शिक्षा परिषद् की बैठक के बाद हुई। यह केंद्र 48 कोस कुरुक्षेत्र के अन्तर्गत आने वाले तीर्थों एवं मंदिरों पर अकादमिक दृष्टि से शोध, अनुसन्धान एवं मानव संसाधन को प्रशिक्षित करने के उद्देश्य से स्थापित किया गया है। विश्वविद्यालय द्वारा दिनांक 15-17 जुलाई 2024 को “मंदिर एवं तीर्थ प्रबन्धन” विषय पर आयोजित तीन दिवसीय राष्ट्रीय कार्यशाला में विशेषज्ञ विद्वानों के विचारों एवं सुझावों से प्राप्त निष्कर्षों के बाद कार्यशाला के समापन सत्र में “48 कोस कुरुक्षेत्र तीर्थ शोध एवं प्रशिक्षण केंद्र” स्थापित करने का प्रस्ताव दिया गया था। प्रस्ताव इस प्रकार है –</p>
                <p><strong>प्रस्ताव</strong></p>
                <p>“दिनांक 15 जुलाई से 17 जुलाई 2024 के दौरान ‘मंदिर एवं तीर्थ प्रबन्धन’ विषय पर आयोजित तीन दिवसीय राष्ट्रीय कार्यशाला के सभी वक्ताओं एवं विषय विशेषज्ञों को सुनने के बाद ध्यान में आया है कि मंदिर एवं तीर्थ न केवल आध्यात्मिक परन्तु सामाजिक और आर्थिक दृष्टि से भी महत्वपूर्ण हैं। देश भर के पर्यटकों में आध्यात्मिक यात्रियों की संख्या सर्वाधिक है और ये संख्या प्रतिवर्ष बढ़ भी रही है। कुरुक्षेत्र के 48 कोसी तीर्थ क्षेत्र के अन्तर्गत आने वाले मंदिर एवं तीर्थ हरियाणा के ऐतिहासिक, सामाजिक, सांस्कृतिक एवं आध्यात्मिक गौरव के प्रतीक हैं। इन तीर्थों के संरक्षण एवं विकास के लिए हरियाणा सरकार द्वारा विविध प्रकल्पों के माध्यम से नित्य प्रोत्साहन मिलता रहता है। इन तीर्थों के प्रामाणिक संदर्भों पर आधारित अकादमिक अनुसन्धान तथा इनके संरक्षण, प्रबन्धन, विकास एवं प्रचार-प्रसार के लिए मानव संसाधन का प्रशिक्षण होना चाहिए।</p>
                <p>48 कोस कुरुक्षेत्र महाभारत कालीन अनेक तीर्थों की भूमि है इसकी पौराणिक, ऐतिहासिक, आध्यात्मिक एवं सामाजिक मान्यताएं हैं। अतः इसके अन्तर्गत आने वाले तीर्थों एवं मंदिरों पर शोधात्मक प्रामाणिक सामग्री उपलब्ध करवाने की महति आवश्यकता है। अभी तक इस विषय पर किए गए कार्यों में अनुसंधान एवं अकादमिक कार्यों की न्यूनता है, इसलिए इसे अकादमिक दृष्टि प्रदान करना समय और समाज इन दोनों की मांग है। इस 48 कोस कुरुक्षेत्र तीर्थ के अन्तर्गत आने वाले अधिकतर तीर्थ एवं मंदिर कैथल क्षेत्र में अधिकता से हैं इसलिए समाज की यह अपेक्षा है कि महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल में आचार्य एवं शोधच्छात्र इस विषय पर शोध करें तथा कैथल क्षेत्र के तीर्थों के संरक्षण एवं संवर्धन हेतु अभ्यर्थी प्रशिक्षण भी प्राप्त करें।</p>
                <p>अतः कार्यशाला में सभी वक्ताओं एवं विशेषज्ञों के विषयों को सुनने और समझने के बाद इस निष्कर्ष पर पहुँचा जा सकता है कि महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल में ‘48 कोस कुरुक्षेत्र तीर्थ शोध एवं प्रशिक्षण केंद्र’ की स्थापना की जाय। यह केंद्र विश्वभर से आने वाले तीर्थयात्रियों को पुरातन भारतीय वैदिक संस्कृति से परिचित कराएगा। साथ ही यह केंद्र सक्षम मानव संसाधन को न केवल प्रशिक्षित करेगा अपितु क्षेत्र के आर्थिक विकास में भी अपना सहयोग प्रदान करेगा। इस शोध केंद्र की स्थापना के साथ ही ‘मंदिर एवं तीर्थ प्रबन्धन’ विषय पर आयोजित यह तीन दिवसीय कार्यशाला इस दैवीय कार्य के मंगलाचरण के रूप में प्रतिष्ठित होगी। यह कार्यशाला विश्वविद्यालय से अनुरोध करती है कि 18 जुलाई 2024 को होने वाली विद्वत्परिषद् की बैठक में इस प्रस्ताव को विचारार्थ एवं स्वीकृति के लिए प्रस्तुत करे”।</p>
                <p>वर्तमान में यह केंद्र शोध, संगोष्ठी, कार्यशाला, प्रकाशन एवं प्रशिक्षण के माध्यम से अपने उद्देश्यों को प्राप्त करने में लगातार अग्रसर है। शोध केंद्र द्वारा मंदिर एवं तीर्थ प्रबन्धन विषय पर एक पुस्तक का भी प्रकाशन किया है। इस केंद्र के प्रथम संयोजक डॉ. गोविन्द वल्लभ हैं।</p>
            </>
        )
    },
    "research-projects": {
        title: "शोध परियोजनाएं",
        content: (
            <>
                <p>उपलब्ध नहीं है।</p>
            </>
        )
    },
    "seminars-workshops": {
        title: "सेमीनार/सम्मेलन/कार्यशाला",
        content: (
            <>
                <p>1. दिनांक 15-17 जुलाई 2024 को ‘मंदिर एवं तीर्थ प्रबन्धन’ विषय पर आयोजित तीन दिवसीय राष्ट्रीय कार्यशाला इस केंद्र की आधारशिला बनी।</p>
            </>
        )
    },
    "research-scholars": {
        title: "शोधार्थी",
        content: (
            <>
                <p>उपलब्ध नहीं है।</p>
            </>
        )
    },
    "achievements": {
        title: "उपलब्धियां",
        content: (
            <>
                <p>1. ग्रंथ का प्रकाशन</p>
                <p>मंदिर एवं तीर्थ प्रबन्धन, सम्पादक – डॉ. गोविन्द वल्लभ, सन् 2025</p>
            </>
        )
    },
    "contact": {
        title: "सम्पर्क",
        content: (
            <div className="table-responsive">
                <table className="table w-100">
                    <tbody>
                        <tr className="shadow-sm bg-light">
                            <th className="text-nowrap">नाम</th>
                            <td>डॉ. गोविन्द वल्लभ</td>
                        </tr>
                        <tr className="shadow-sm bg-white">
                            <th className="text-nowrap">पद</th>
                            <td>संयोजक, 48 कोस कुरुक्षेत्र तीर्थ शोध एवं प्रशिक्षण केंद्र</td>
                        </tr>
                        <tr className="shadow-sm bg-light">
                            <th className="text-nowrap">मोबाइल नं.</th>
                            <td>70115-04209</td>
                        </tr>
                        <tr className="shadow-sm bg-white">
                            <th className="text-nowrap">ईमेल</th>
                            <td>
                                <a href="mailto:48kosktrtc@mvsu.ac.in">48kosktrtc@mvsu.ac.in</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

};

export default function KosKurukshetraResearchTrainingCenter() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [currentContent, setCurrentContent] = useState(contentData["about"].content);
    const [currentTitle, setCurrentTitle] = useState(contentData["about"].title);
    const [activeItem, setActiveItem] = useState("about");

    useEffect(() => {
        // Set initial content and title to "परिचय"
        setCurrentContent(contentData["about"].content);
        setCurrentTitle(contentData["about"].title);
        setActiveItem("about");

        const handleResize = () => {
            if (window.innerWidth >= 768) { // md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId].content);
        setCurrentTitle(contentData[deptId].title);
        setActiveItem(deptId);

        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-md-row vh-100">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">48 कोस कुरुक्षेत्र तीर्थ शोध एवं प्रशिक्षण केंद्र</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className="mb-1 p-2 rounded shadow-sm small"
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeItem === dept.id ? "#77236b" : "#fff",
                                color: activeItem === dept.id ? "#fff" : "#000",
                                fontWeight: activeItem === dept.id ? "bold" : "normal",
                                border: "1px solid transparent",
                                transition: "all 0.2s"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <h5 className="mb-3 text-center fw-bold" style={{ color: "#77236b" }}>
                    {currentTitle}
                </h5>
                <div>{currentContent}</div>
            </main>
        </div>
    );
}